import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Font loading detection for better performance
const addFontsLoadedClass = () => {
  const docElement = document.documentElement;
  if (docElement) {
    docElement.classList.add('fonts-loaded');
  }
};

if (typeof document !== 'undefined' && 'fonts' in document) {
  // Only load essential font weights to reduce payload
  Promise.all([
    (document as any).fonts.load('400 1em Inter'),
    (document as any).fonts.load('500 1em Inter'),
    (document as any).fonts.load('600 1em Inter'),
    (document as any).fonts.load('700 1em Inter'),
  ]).then(() => {
    addFontsLoadedClass();
  }).catch(() => {
    // Fallback if fonts fail to load
    addFontsLoadedClass();
  });
} else {
  // Fallback for browsers without Font Loading API
  addFontsLoadedClass();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 